module.exports = __webpack_public_path__ + "static/media/info02_Correo_validado.145a26a3.png";